/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
(function (Drupal, $) {
	"use strict";

	function handleHeaderHeight(context) {
		var header = $(".header-toolbar", context);
		var headerHeight = header.outerHeight();
		$(".menu--main", context).css("top", headerHeight);
		$("body", context).css("margin-top", headerHeight);
	}

	function handleHeaderWindowResize(context) {
		$(window).on("resize", function () {
			handleHeaderHeight(context);
		});
	}

	function initHeaderHeight(context) {
		handleHeaderHeight(context);
	}

	Drupal.behaviors.handleHeaderWindowResize = {
		attach: handleHeaderWindowResize,
	};
	Drupal.behaviors.initHeaderHeight = { attach: initHeaderHeight };
})(Drupal, jQuery);
